import axios from "axios";
import { Magic } from "magic-sdk";
import { transactionSourceEnum } from "@/store/modules/user/enums";
import store from "../../index";
import * as Sentry from "@sentry/vue";
import { hasLoadedCurrenciesForCart } from "@/utils/currenciesLoader";
import {
  getCurrenciesCacheKey,
  getPreviousTransactionCacheKey,
  getStockExchangesCacheKey,
  shouldFetchUserInfo,
} from "@/utils/sessionDataCache";

const currenciesInflight = new Map();
import {
  GET_USER_INFO,
  GET_STOCKS,
  GET_BANKS,
  GET_TXS,
  GET_STORES,
  GET_SETTINGS,
  SET_SETTINGS,
  GET_CURRENCIES,
  PURCHASE_EXTERNAL,
  PURCHASE_APPROVE,
  GET_MARKET_INFO,
  PURCHASE_CHECK,
  ADD_COINBASE,
  GET_EXCHANGES,
  ADD_BINANCE,
  ADD_KRAKEN,
  DELETE_STOCK,
  GET_EXTERNAL_STATUS,
  GET_EXTERNAL_STATUS_EVENT,
  GET_PAYMENT_OPTIONS,
  ADD_BANK,
  CURRENCY_COMPARE,
  AUTH_EXCHANGE,
  CHECK_BALANCE,
  VALIDATE_EXCHANGE_PAYMENT,
  EXCHANGE_PAYMENT,
  GET_STOCK_EXCHANGES,
  GET_EXCHANGES_DEPOSIT_ADDRESS,
  LIMIT_UPDATE,
  DEFAULT_EXCHANGE,
  PURCHASE,
  SET_ACCOUNT,
  SET_TAB,
  WEBSOCKET_RESPONSES,
  GET_PAYABLE_AMOUNT,
  GET_PREVIOUS_TRANSACTION_DATA,
  IFRAME_STATUS,
  USER_TRACK_EVENTS,
  WALLET_PAYMENT_CONFIRMED,
  SET_HOSTED_PAGE_INFO,
  SET_RESULT_PAGE_DATA,
  FORM_OPENED,
  RAISE_PARTIAL_REFUND,
  CHECK_KYT,
  FEEDBACK_STATE,
  CHECK_REWARDS_OPTIN_STATUS,
  ENROLL_REWARDS_PROGRAM,
  ESITMATE_REWARDS,
  GET_REWARDS_BALANCE,
  GET_SUMSUB_CREATE,
  GET_SUMSUB_OBTAIN,
  GET_SUMSUB_STATUS,
  GET_AMLBOT_CREATE,
  GET_AMLBOT_OBTAIN,
  GET_AMLBOT_STATUS,
} from "./consts";

import { sendPaymentResult } from "@/utils/paymentResultEvents";
import { CRYPTO_TAB } from "../../../utils/stringconsts";
import config from "../../../utils/config";
import app from "@/main";
import { isInIframe } from "@/utils/helper";

const BASE_URL = process.env.VUE_APP_BASE_URL || "/api";
const BASE_URL2 = process.env.VUE_APP_BASE_URL_2 || "/api";
const magic = new Magic(config.magic.publishableKey);

function doesContainCode() {
  const containsAuthCode = window.location.href.split("?code=");
  if (containsAuthCode[1]) {
    return true;
  }
  return false;
}
function doesHaveAccessToken() {
  const rkflAccess =
    app.config.globalProperties.$DbStorage.getItem("rocketfuel_access");
  if (rkflAccess) {
    return true;
  }
  return false;
}

function doesHaveParentOpener() {
  // eslint-disable-next-line no-unneeded-ternary
  return window.opener ? true : false;
}

export default {
  async [CURRENCY_COMPARE]({ commit, state }, data) {
    const reqParam = {
      to: data.to,
      from: data.from,
    };
    const cached = state.conversionInfo?.reqParam;
    if (
      cached &&
      cached.from === reqParam.from &&
      cached.to === reqParam.to &&
      state.conversionInfo[reqParam.to] !== undefined
    ) {
      return {
        ...state.conversionInfo,
        reqParam,
        status: "ok",
      };
    }
    const source = data.source || transactionSourceEnum.DEFAULT;
    window.EventBus.emit("ADD_INFO_MESSAGE", {
      message: "get currency conversion",
    });
    const resp = await axios.get(
      `${BASE_URL}/compare-currecy`,
      {
        params: reqParam,
      },
      { headers: { "x-transaction-source": source } }
    );

    window.EventBus.emit("DELETE_INFO_MESSAGE", { message: "get user info" });

    commit("setConversionInfo", { ...resp.data.result, reqParam });

    return { ...resp.data.result, reqParam, status: "ok" };
  },

  async [GET_USER_INFO]({ commit, state }, options) {
    // force is required after a signin: the cached info belongs to the guest session
    if (options?.force !== true && !shouldFetchUserInfo(state)) {
      return state.userInfo;
    }
    try {
      window.EventBus.emit("ADD_INFO_MESSAGE", { message: "get user info" });
      const resp = await axios.get(`${BASE_URL}/user/me`);

      commit("setUserInfo", resp.data.result);
      commit("setEnableDashboard", resp?.data?.result?.enableDashboard);
      commit("setIsLoginWithoutEmail", resp?.data?.result?.isStaticEmail);
      commit("patchApiCache", { userInfoLoaded: true });
      Sentry.setUser({
        email: resp?.data?.result?.email?.toLowerCase(),
        id: resp?.data?.result?.id,
      });
      window.EventBus.emit("DELETE_INFO_MESSAGE", { message: "get user info" });
      return resp.data.result;
    } catch (err) {
      return err;
    }
  },
  async [FEEDBACK_STATE]({ commit, state }) {
    if (state.apiCache?.feedbackLoaded) {
      return state.showFeedback;
    }
    try {
      const feedResp = await axios.get(`${BASE_URL}/user/feedback`);
      commit("setFeedbackState", feedResp?.data?.result?.showFeedback);
      commit("patchApiCache", { feedbackLoaded: true });
      return feedResp?.data?.result?.showFeedback;
    } catch (err) {
      return err;
    }
  },
  async [GET_STOCKS]({ commit }, data) {
    window.EventBus.emit("ADD_INFO_MESSAGE", { message: "get stocks" });
    let payload;
    if (typeof data === "object" && "update" in data) {
      payload = data.update;
    } else {
      payload = data;
    }
    const resp = await axios.get(`${BASE_URL}/stock-market/my`, {
      params: {
        update: payload,
      },
    });

    // TODO this is hardcode. скрывание силы
    const stocks = resp.data.result;
    window.EventBus.emit("DELETE_INFO_MESSAGE", { message: "get stocks" });
    commit("setStocks", stocks);
    return stocks;
  },

  // eslint-disable-next-line no-unused-vars
  async [GET_BANKS]({ commit }, payload) {
    try {
      const source = payload.source || transactionSourceEnum.DEFAULT;

      const resp = await axios.get(`${BASE_URL}/banks/list`, {
        headers: { "x-transaction-source": source },
      });
      const { result } = resp.data;

      // window.EventBus.emit('DELETE_INFO_MESSAGE', { message: 'get stocks' });
      return result;
    } catch (e) {
      return e;
    }
  },
  async [GET_TXS]({ commit }) {
    window.EventBus.emit("ADD_INFO_MESSAGE", { message: "get transactions" });
    const resp = await axios.get(`${BASE_URL}/tx?limit=3&offset=0`);

    window.EventBus.emit("DELETE_INFO_MESSAGE", {
      message: "get transactions",
    });

    commit("setTxs", resp.data.result);
  },

  async [GET_STORES]({ commit }, data) {
    window.EventBus.emit("ADD_INFO_MESSAGE", { message: "get stores" });
    let resp = {};
    if (data) {
      resp = await axios.get(`${BASE_URL}/stores`, {
        params: {
          offset: data.offset ? data.offset : 0,
          limit: data.limit,
        },
      });
    } else {
      resp = await axios.get(`${BASE_URL}/stores`);
    }

    window.EventBus.emit("DELETE_INFO_MESSAGE", { message: "get stores" });

    commit("setStores", resp.data.result);
  },

  async [GET_MARKET_INFO]({ commit, state }, payload) {
    const merchantId = payload?.merchantId;
    const cachedMerchantId = state.apiCache?.marketInfoMerchantId;
    if (
      cachedMerchantId === String(merchantId) &&
      state.marketInfo?.merchant &&
      Object.keys(state.marketInfo?.settings || {}).length
    ) {
      return state.marketInfo;
    }
    window.EventBus.emit("ADD_INFO_MESSAGE", { message: "get market info" });
    const source = payload.source || transactionSourceEnum.DEFAULT;
    try {
      const resp = await axios.get(`${BASE_URL}/store/${payload.merchantId}`, {
        headers: { "x-transaction-source": source },
      });

      window.EventBus.emit("DELETE_INFO_MESSAGE", {
        message: "get market info",
      });

      commit("setMarketInfo", resp.data.result);
      commit("patchApiCache", { marketInfoMerchantId: String(merchantId) });
      return resp.data.result;
    } catch (error) {
      console.error({
        error: error?.response?.data?.message || error?.message,
      });
      return state.marketInfo;
    }
  },

  // eslint-disable-next-line
  async [PURCHASE_CHECK]({ commit }, data) {
    const resp = await axios.post(`${BASE_URL}/purchase/check`, { data });
    return resp.data.result.errorMessage;
  },

  // eslint-disable-next-line
  async [PURCHASE](
    { commit },
    { data, code2fa, source = transactionSourceEnum.DEFAULT }
  ) {
    // const date = new Date();
    // const offset = date.getTimezoneOffset();
    try {
      let resp;

      if (code2fa) {
        window.EventBus.emit("ADD_INFO_MESSAGE", { message: "purchase" });
        resp = await axios.post(
          `${BASE_URL}/purchase`,
          { data },
          {
            headers: {
              "rf-2fa": code2fa,
              "x-transaction-source": source,
            },
          }
        );

        window.EventBus.emit("DELETE_INFO_MESSAGE", { message: "purchase" });
      } else {
        window.EventBus.emit("ADD_INFO_MESSAGE", { message: "purchase" });
        resp = await axios.post(
          `${BASE_URL}/purchase`,
          { data },
          { headers: { "x-transaction-source": source } }
        );

        window.EventBus.emit("DELETE_INFO_MESSAGE", { message: "purchase" });
      }
      if (resp.data.result) {
        commit("setRefrenceId", resp.data.result.id);
        sendPaymentResult(
          {
            type: "rocketfuel_result_ok",
            response: {
              paymentMode: "Bank/Exchange",
              txn_id: resp.data.result.id,
              status: resp.data.result.status,
              meta: resp.data.result.meta,
            },
            paymentCompleted: 1,
          },
          store.getters["user/marketInfo"]
        );
        return {
          status: "ok",
          response: resp.data.result,
        };
      }
      return {
        status: "not ok",
        response: resp,
      };
    } catch (error) {
      return {
        status: "error",
        response: error.response.data.message,
        data: error.response.data,
      };
    }
  },

  // eslint-disable-next-line
  async [PURCHASE_APPROVE]({ commit }, data) {
    try {
      window.EventBus.emit("ADD_INFO_MESSAGE", { message: "purchase" });
      const resp = await axios.post(`${BASE_URL}/purchase/approve`, data);

      window.EventBus.emit("DELETE_INFO_MESSAGE", { message: "purchase" });
      if (resp.data.result) {
        sendPaymentResult(
          {
            type: "rocketfuel_result_ok",
            paymentCompleted: 1,
          },
          store.getters["user/marketInfo"]
        );
        return {
          status: "ok",
          response: resp.data.result,
        };
      }
      return {
        status: "not ok",
        response: resp,
      };
    } catch (error) {
      return {
        status: "error",
        response: error.response.data.message,
      };
    }
  },

  async [GET_SETTINGS]({ commit, state }, payload = {}) {
    const force = Boolean(payload?.force);
    if (
      !force &&
      state.apiCache?.settingsLoaded &&
      state.settings &&
      Object.keys(state.settings).length
    ) {
      return state.settings;
    }
    try {
      window.EventBus.emit("ADD_INFO_MESSAGE", { message: "get settings" });
      const resp = await axios.get(`${BASE_URL}/user/payment-settings`);

      window.EventBus.emit("DELETE_INFO_MESSAGE", { message: "get settings" });

      commit("setUserSettings", resp.data.result);
      commit("patchApiCache", { settingsLoaded: true });

      return resp.data.result;
    } catch (err) {
      return state.settings || {};
    }
  },
  // eslint-disable-next-line
  async [SET_SETTINGS]({ commit, state }, settings) {
    try {
      window.EventBus.emit("ADD_INFO_MESSAGE", { message: "set settings" });
      const resp = await axios.post(
        `${BASE_URL}/user/payment-settings`,
        settings
      );
      await magic.user.logout();

      window.EventBus.emit("DELETE_INFO_MESSAGE", { message: "set settings" });

      const result = resp.data.result;
      if (result?.success !== false) {
        commit("setUserSettings", {
          ...state.settings,
          ...settings,
          isUserConfigured: true,
        });
        commit("patchApiCache", { settingsLoaded: true });
      }
      return result;
    } catch (e) {
      return e.response.data.message;
    }
  },
  async [GET_CURRENCIES]({ commit, state }, { merchantId, amount, currency }) {
    const cacheKey = getCurrenciesCacheKey({
      merchant_id: merchantId,
      amount,
      currency,
    });
    if (!cacheKey) {
      return state.currencies || [];
    }
    if (
      hasLoadedCurrenciesForCart(state, {
        merchant_id: merchantId,
        amount,
        currency,
      })
    ) {
      return state.currencies;
    }

    if (currenciesInflight.has(cacheKey)) {
      return currenciesInflight.get(cacheKey);
    }

    const request = (async () => {
      window.EventBus.emit("ADD_INFO_MESSAGE", { message: "get currencies" });
      let queryString = "";
      if (amount && currency) {
        queryString += `&amount=${amount}&currency=${currency}`;
      }
      try {
        const resp = await axios.get(
          `${BASE_URL}/currencies?merchant_id=${merchantId}${queryString}&include_merchant=true`
        );
        const currencies = (resp.data.result || []).filter(
          (item) => item.id !== "SILAUSD"
        );
        window.EventBus.emit("DELETE_INFO_MESSAGE", {
          message: "get currencies",
        });
        commit("setCurrencies", currencies);
        commit("setCurrenciesCacheKey", cacheKey);
        return currencies;
      } catch (error) {
        window.EventBus.emit("DELETE_INFO_MESSAGE", {
          message: "get currencies",
        });
        throw error;
      } finally {
        currenciesInflight.delete(cacheKey);
      }
    })();

    currenciesInflight.set(cacheKey, request);
    return request;
  },

  // eslint-disable-next-line
  async [PURCHASE_EXTERNAL]({ commit }, data) {
    // To get access to header source,
    // we need to pass data as an object with source and encrypted as keys
    try {
      window.EventBus.emit("ADD_INFO_MESSAGE", {
        message: "create transaction",
      });
      const source = data.source || transactionSourceEnum.DEFAULT;
      const resp = await axios.post(
        `${BASE_URL}/purchase/external`,
        { data: data.encrypted },
        { headers: { "x-transaction-source": source } }
      );
      commit("setRefrenceId", resp.data.result.id);
      window.EventBus.emit("DELETE_INFO_MESSAGE", {
        message: "create transaction",
      });

      if (resp.data.result) {
        return {
          status: "ok",
          response: resp.data.result,
        };
      }
      return {
        status: "not ok",
        response: resp,
      };
    } catch (error) {
      return {
        status: "error",
        response: error.response.data.message,
      };
    }
  },

  // eslint-disable-next-line
  async [ADD_COINBASE]({ dispatch }, code) {
    try {
      window.EventBus.emit("ADD_INFO_MESSAGE", { message: "add coinbase" });
      await axios.post(`${BASE_URL}/stock-market/coinbase/add`, {
        code,
        redirect: window.location.origin,
      });

      window.EventBus.emit("ADD_INFO_MESSAGE", { message: "add coinbase" });
      if (window.opener) {
        window.opener.postMessage({
          type: "rocketfuel_connect_result",
          value: "coinbase",
          success: true,
          errorMessage: "",
        });
      }
    } catch (e) {
      if (window.opener) {
        window.opener.postMessage({
          type: "rocketfuel_connect_result",
          value: "coinbase",
          success: false,
          errorMessage: e.response ? e.response.data.message : e.message,
        });
      }
    }
  },

  async [GET_EXCHANGES]({ commit, state }) {
    if (state.apiCache?.exchangesListLoaded && state.allStocks?.length) {
      return state.allStocks;
    }
    window.EventBus.emit("ADD_INFO_MESSAGE", { message: "get exchanges" });
    const resp = await axios.get(`${BASE_URL}/exchanges`);

    window.EventBus.emit("DELETE_INFO_MESSAGE", { message: "get exchanges" });

    commit("setExchanges", resp.data.result);
    commit("patchApiCache", { exchangesListLoaded: true });

    return resp.data.result;
  },

  async [GET_PAYMENT_OPTIONS]({ commit }, merchantId) {
    const resp = await axios.get(
      `${BASE_URL}/merchant/paymentoption?merchant_id=${merchantId}`
    );
    commit("setPaymentOptions", resp.data.result);
    return resp.data.result;
  },

  // eslint-disable-next-line
  async [ADD_BINANCE]({ commit }, data) {
    window.EventBus.emit("ADD_INFO_MESSAGE", { message: "add binance" });
    const resp = await axios.post(`${BASE_URL}/stock-market/binance/add`, data);

    window.EventBus.emit("DELETE_INFO_MESSAGE", { message: "add binance" });

    return resp.data.result;
  },

  // eslint-disable-next-line
  async [ADD_KRAKEN]({ commit }, data) {
    window.EventBus.emit("ADD_INFO_MESSAGE", { message: "add kraken" });
    const resp = await axios.post(`${BASE_URL}/stock-market/kraken/add`, data);

    window.EventBus.emit("DELETE_INFO_MESSAGE", { message: "add kraken" });

    return resp.data.result;
  },

  // eslint-disable-next-line
  async [DELETE_STOCK]({ commit }, payload) {
    window.EventBus.emit("ADD_INFO_MESSAGE", { message: "delete stock" });
    const source = payload.source || transactionSourceEnum.DEFAULT;

    await axios.delete(`${BASE_URL}/exchange/delete/${payload.id}`, {
      headers: { "x-transaction-source": source },
    });

    window.EventBus.emit("DELETE_INFO_MESSAGE", { message: "delete stock" });
  },

  // eslint-disable-next-line no-unused-vars
  async [ADD_BANK]({ commit }, model) {
    const resp = await axios.post(
      `${BASE_URL}/stock-market/dwolla/add-bank`,
      model
    );

    await magic.user.logout();

    return resp;
  },

  // eslint-disable-next-line no-unused-vars
  async [AUTH_EXCHANGE]({ commit, dispatch }, data) {
    try {
      const merchantId =
        app.config.globalProperties.$DbStorage.getItem("merchant_id");
      const payload = {
        data: data.requestPayload,
        limit: data.limit || 1000,
        merchantId,
      };
      window.EventBus.emit("ADD_INFO_MESSAGE", { message: "add exchange" });
      const access =
        app.config.globalProperties.$DbStorage.getItem("rocketfuel_access");
      let resp = null;
      if (
        doesContainCode() &&
        doesHaveAccessToken() &&
        !doesHaveParentOpener()
      ) {
        // For Safari fix
        resp = await axios.post(
          `${BASE_URL}/exchange/auth/${data.name}`,
          payload,
          {
            headers: {
              authorization: `Bearer ${access}`, // the token is a variable which holds the token
            },
          }
        );
        window.EventBus.emit("ADD_INFO_MESSAGE", { message: "add exchange" });
        app.config.globalProperties.$DbStorage.removeItem("merchant_id");
        if (data.name === "coinbase") {
          // eslint-disable-next-line no-alert
          dispatch(`${SET_TAB}`, CRYPTO_TAB);
          window.EventBus.emit("CONNECTION_RESULT", {
            type: "rocketfuel_connect_result",
            value: "coinbase",
            success: true,
            errorMessage: "",
          });
        }
      } else {
        resp = await axios.post(
          `${BASE_URL}/exchange/auth/${data.name}`,
          payload
        );
        window.EventBus.emit("ADD_INFO_MESSAGE", { message: "add exchange" });
        if (data.name === "coinbase" && doesHaveParentOpener()) {
          window.opener.postMessage({
            type: "rocketfuel_connect_result",
            value: "coinbase",
            success: true,
            errorMessage: "",
          });
        }
      }
      return resp;
    } catch (e) {
      if (data.name === "coinbase") {
        if (
          doesContainCode() &&
          doesHaveAccessToken() &&
          !doesHaveParentOpener()
        ) {
          // For Safari fix
          window.EventBus.emit("CONNECTION_RESULT", {
            type: "rocketfuel_connect_result",
            value: "coinbase",
            success: false,
            errorMessage: "",
          });
        } else if (doesHaveParentOpener()) {
          window.opener.postMessage({
            type: "rocketfuel_connect_result",
            value: "coinbase",
            success: false,
            errorMessage: e.response ? e.response.data.message : e.message,
          });
        }
      }
      return { error: e };
    }
  },

  // eslint-disable-next-line no-unused-vars
  async [CHECK_BALANCE]({ commit }, data) {
    // set a source if none is available
    const source = data.source || transactionSourceEnum.DEFAULT;

    const resp = await axios.get(
      `${BASE_URL}/exchange/check-balance/${data.exchange}?merchantId=${data.clientId}`,
      { headers: { "x-transaction-source": source } }
    );
    return resp;
  },

  // eslint-disable-next-line no-unused-vars
  async [VALIDATE_EXCHANGE_PAYMENT]({ commit }, payload) {
    const source = payload.source || transactionSourceEnum.DEFAULT;

    const resp = await axios.post(
      `${BASE_URL}/exchange/payment-validate/${payload.exchange}`,
      { data: payload.data },
      { headers: { "x-transaction-source": source } }
    );
    return resp;
  },

  // eslint-disable-next-line no-unused-vars
  async [EXCHANGE_PAYMENT]({ commit }, payload) {
    window.EventBus.emit("ADD_INFO_MESSAGE", { message: "purchase" });
    const source = payload.source || transactionSourceEnum.DEFAULT;
    const resp = await axios.post(
      `${BASE_URL}/exchange/payment/${payload.exchange}`,
      { data: payload.data },
      { headers: { "x-transaction-source": source } }
    );
    if (resp.data.result) {
      commit("setRefrenceId", resp.data.result.id);
      sendPaymentResult(
        {
          type: "rocketfuel_result_ok",
          response: {
            paymentMode: "Bank/Exchange",
            txn_id: resp.data.result.id,
            status: resp.data.result.status,
            meta: resp.data.result.meta,
            offerId: payload.offerId,
            paymentCompleted: 1,
          },
          paymentCompleted: 1,
        },
        store.getters["user/marketInfo"]
      );
      return resp;
    }
    return resp;
  },
  async [GET_STOCK_EXCHANGES](
    { commit, state },
    { clientId, source = transactionSourceEnum.DEFAULT }
  ) {
    const cacheKey = getStockExchangesCacheKey(clientId, source);
    if (
      state.apiCache?.stockExchangesKey === cacheKey &&
      state.stockExchanges &&
      (state.stockExchanges.exchanges?.length ||
        Object.keys(state.stockExchanges).length)
    ) {
      return state.stockExchanges;
    }
    // payload is now an object to allow multiple parameters
    window.EventBus.emit("ADD_INFO_MESSAGE", {
      message: "get stock exchanges info",
    });

    const resp = await axios.get(
      `${BASE_URL}/exchange/list?merchantId=${clientId}`,
      { headers: { "x-transaction-source": source } }
    );

    window.EventBus.emit("DELETE_INFO_MESSAGE", {
      message: "get stock exchanges info",
    });

    commit("setStockExchanges", resp.data.result);
    commit("patchApiCache", { stockExchangesKey: cacheKey });

    return resp.data.result;
  },
  async [GET_EXCHANGES_DEPOSIT_ADDRESS]({ commit }, payload) {
    window.EventBus.emit("ADD_INFO_MESSAGE", {
      message: "get stock exchanges info",
    });
    const resp = await axios.get(
      `${BASE_URL}/exchange/deposit-address?currency=${payload.currency}&merchantId=${payload.merchantId}`
    );

    window.EventBus.emit("DELETE_INFO_MESSAGE", {
      message: "get stock exchanges info",
    });

    commit("setStockExchanges", resp.data.result);

    return resp.data.result;
  },
  // eslint-disable-next-line no-unused-vars
  async [LIMIT_UPDATE]({ commit }, payload) {
    const source = payload.source || transactionSourceEnum.DEFAULT;
    const resp = await axios.post(
      `${BASE_URL}/exchange/limit-increase/${payload.exchange}`,
      {
        limit: payload.limit,
      },
      { headers: { "x-transaction-source": source } }
    );
    return resp.data;
  },
  async [DEFAULT_EXCHANGE]({ commit }, payload) {
    commit("setSelectedExchange", payload);
  },
  // eslint-disable-next-line no-unused-vars
  async [SET_ACCOUNT]({ commit }, account) {
    commit("setAccount", account);
  },
  // eslint-disable-next-line no-unused-vars
  async [SET_TAB]({ commit }, tab) {
    commit("setTab", tab);
  },
  // eslint-disable-next-line no-unused-vars
  async [GET_EXTERNAL_STATUS]({ commit }, payload) {
    try {
      const source = payload.source || transactionSourceEnum.DEFAULT;

      // eslint-disable-next-line no-param-reassign
      delete payload.source; // remove source from payload

      const resp = await axios.post(
        `${BASE_URL}/purchase/external-status`,
        payload,
        { headers: { "x-transaction-source": source } }
      );
      return resp;
    } catch (e) {
      return e;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async [GET_PAYABLE_AMOUNT]({ commit }, params) {
    const resp = await axios.get(`${BASE_URL}/users/payable-amounts`, {
      params,
    });

    return resp.data.result;
  },
  async [WEBSOCKET_RESPONSES]({ commit }, payload) {
    commit("setSocketResponse", payload);
  },
  // eslint-disable-next-line no-unused-vars
  async [GET_PREVIOUS_TRANSACTION_DATA]({ commit, state }, payload) {
    const cacheKey = getPreviousTransactionCacheKey(payload);
    const cached = state.apiCache?.previousTransactionResult;
    if (
      cacheKey &&
      state.apiCache?.previousTransactionKey === cacheKey &&
      cached !== null &&
      typeof state.apiCache?.previousTransactionAt === "number" &&
      Date.now() - state.apiCache.previousTransactionAt < 20000
    ) {
      return cached;
    }

    const response = await axios({
      method: "GET",
      url: `${BASE_URL}/purchase/transaction/partials/${payload.merchant_id}`,
      params: {
        hostedPageId: payload.hostedPageId,
        offerId: payload.offerId,
      },
    });
    const result = response?.data?.result;
    commit("setPreviousTransactionCache", { key: cacheKey, result });
    return result;
  },

  // eslint-disable-next-line
  async [IFRAME_STATUS]({ commit }, data) {
    try {
      const resp = await axios.post(`${BASE_URL}/purchase/iframeStatus`, data);
      return resp.resp;
    } catch (error) {
      return {
        status: "error",
        response: error?.response?.data?.message || error?.message || "",
      };
    }
  },
  async [USER_TRACK_EVENTS](_, data) {
    try {
      if (!data?.moduleInfo) {
        return {
          status: "error",
          response: "moduleInfo is required",
        };
      }
      const marketInfo = store.getters["user/marketInfo"];
      // eslint-disable-next-line no-param-reassign
      data.moduleInfo.merchantId =
        data.moduleInfo.merchantId || marketInfo?.merchant?.id;
      // eslint-disable-next-line no-param-reassign
      data.serviceName =
        data.serviceName ||
        (isInIframe() ? "IFRAME_EVENTS" : "PAYMENT_PAGE_EVENTS");
      // eslint-disable-next-line no-param-reassign
      data.moduleInfo.storeName =
        data.moduleInfo.storeName || marketInfo?.merchant?.shopData?.companyName;
      // eslint-disable-next-line no-param-reassign
      if (!data.moduleInfo.meta) {
        data.moduleInfo.meta = {};
      }
      // eslint-disable-next-line no-param-reassign
      data.moduleInfo.meta.pathname =
        data.moduleInfo.meta.pathname || window.location.pathname;
      // console.log({data}, 'USER_TRACK_EVENTS}')
      const resp = await axios.post(`${BASE_URL}/addActivity`, data);
      return resp.resp;
    } catch (error) {
      return {
        status: "error",
        response: error?.response?.data?.message || error.message,
      };
    }
  },
  async [WALLET_PAYMENT_CONFIRMED](_, data) {
    const source = data.source || transactionSourceEnum.DEFAULT;
    const resp = await axios.post(
      `${BASE_URL}/purchase/wallet-payment-confimed`,
      { data: data.encrypted },
      {
        headers: { "x-transaction-source": source },
      }
    );
    return resp.data;
  },
  async [SET_HOSTED_PAGE_INFO]({ commit }, hostedPageId) {
    commit("setHostedPageId", hostedPageId);
    return;
  },
  async [SET_RESULT_PAGE_DATA]({ commit }, data) {
    commit("setResultPageData", data);
    return;
  },
  async [FORM_OPENED]() {
    try {
      const resp = await axios.post(`${BASE_URL}/user/feedback/opened`);
      return resp.data;
    } catch (e) {
      return e;
    }
  },
  async [RAISE_PARTIAL_REFUND](_, payload) {
    const resp = await axios.post(
      `${BASE_URL}/purchase/partial/refund`,
      payload
    );
    return resp?.data?.result;
  },
  async [CHECK_KYT](_, payload) {
    const resp = await axios.post(`${BASE_URL}/purchase/kyt`, payload);
    return resp?.data?.result;
  },
  async [GET_EXTERNAL_STATUS_EVENT]({ commit }, payload) {
    try {
      const url = `${BASE_URL2}/purchase/external-status-events/${payload.encrypt}`;
      const resp = await axios.get(url);

      return resp;
    } catch (e) {
      return e;
    }
  },
  async [CHECK_REWARDS_OPTIN_STATUS]({ commit, state }, options) {
    const marketInfo = store.getters["user/marketInfo"];
    const merchantId = marketInfo?.merchant?.id;
    if (!merchantId) {
      return state.enrolledInRewards;
    }
    if (
      options?.force !== true &&
      state.apiCache?.rewardsOptInMerchantId === String(merchantId) &&
      state.enrolledInRewards &&
      Object.keys(state.enrolledInRewards).length
    ) {
      return state.enrolledInRewards;
    }
    const response = await axios.get(
      `${BASE_URL}/rewards/opt-status/${merchantId}`
    );
    commit("setEnrolledInRewards", response?.data?.result);
    commit("patchApiCache", { rewardsOptInMerchantId: String(merchantId) });
    if (response?.data?.result?.optIn === true) {
      commit("setRewardsOptInPending", false);
    }
    return response?.data?.result;
  },
  async [ENROLL_REWARDS_PROGRAM]({ commit }, txId) {
    const marketInfo = store.getters["user/marketInfo"];
    // eslint-disable-next-line no-param-reassign
    const merchantId = marketInfo?.merchant?.id;
    let payload = {
      enrollmentSource: "PAYMENT_PAGE",
    };
    if (txId) {
      payload = {
        ...payload,
        txId,
      };
    }
    const response = await axios.post(
      `${BASE_URL}/rewards/opt-in/${merchantId}`,
      payload
    );
    commit("setRewardsOptInPending", true);
    // Let the next status check hit the API instead of the pre-enrollment value
    commit("patchApiCache", { rewardsOptInMerchantId: null });
    return response?.data?.result;
  },
  async [ESITMATE_REWARDS]({ commit }, payload) {
    const marketInfo = store.getters["user/marketInfo"];
    // eslint-disable-next-line no-param-reassign
    const merchantId = marketInfo?.merchant?.id;
    const response = await axios.get(
      `${BASE_URL}/rewards/predict/${merchantId}?amount=${payload.amount}&currency=${payload.currency}`
    );
    commit("setEstimatedRewards", response?.data?.result);
    return response?.data?.result;
  },
  async [GET_REWARDS_BALANCE]({ commit }) {
    const marketInfo = store.getters["user/marketInfo"];
    // eslint-disable-next-line no-param-reassign
    const merchantId = marketInfo?.merchant?.id;
    const response = await axios.get(
      `${BASE_URL}/rewards/balance/${merchantId}`
    );
    commit("setRewardsBalance", response?.data?.result);
    return response?.data?.result;
  },
  async setContinuedTransaction({ commit }, data) {
    commit("continuedTransaction", data);
  },
  async [GET_SUMSUB_CREATE]({ commit }) {
    const resp = await axios.get(`${BASE_URL}/sumsub/create?user=iframe`);
    return resp?.data?.result?.data ?? null;
  },
  async [GET_SUMSUB_OBTAIN]({ commit }) {
    const resp = await axios.get(`${BASE_URL}/sumsub/obtain?user=iframe`);
    return resp?.data?.result?.data ?? null;
  },
  async [GET_SUMSUB_STATUS]({ commit }) {
    const resp = await axios.get(`${BASE_URL}/sumsub/status`);
    return resp?.data?.result?.data ?? null;
  },
  async [GET_AMLBOT_CREATE]({ commit }) {
    const resp = await axios.get(`${BASE_URL}/amlbot/create`);
    return resp?.data?.result?.data ?? null;
  },
  async [GET_AMLBOT_OBTAIN]({ commit }) {
    const resp = await axios.get(`${BASE_URL}/amlbot/obtain`);
    return resp?.data?.result?.data ?? null;
  },
  async [GET_AMLBOT_STATUS]({ commit }) {
    const resp = await axios.get(`${BASE_URL}/amlbot/status`);
    return resp?.data?.result?.data ?? null;
  },
};
